import { render, staticRenderFns } from "./household_allowances.vue?vue&type=template&id=6fbdf08a"
import script from "./household_allowances.vue?vue&type=script&lang=js"
export * from "./household_allowances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports